import axios from "axios";

const SITE_URI_PREFIX = "/v1/site";
const SITE_URIS = {
  GET_LIST_SITE: `${SITE_URI_PREFIX}/list`,
  GET_LIST_IMPORT_CONFIRM: `${SITE_URI_PREFIX}/list-confirm`,
  IMPORT_CONTINUE: `${SITE_URI_PREFIX}/import-continue`,
  GET_DETAIL_HISTORY_SITE : `${SITE_URI_PREFIX}/detail-history`,
  
};

export default {
  getListSite(params, signal) {
    return axios.get(SITE_URIS.GET_LIST_SITE, { params, signal });
  },
  getListConfirmImportSite(params) {
    return axios.get(SITE_URIS.GET_LIST_IMPORT_CONFIRM, { params });
  },
  getListDetailHistory(params){
    return axios.get(SITE_URIS.GET_DETAIL_HISTORY_SITE, { params });
  },
  importContinueSite(data) {
    return axios.post(SITE_URIS.IMPORT_CONTINUE, data);
  },
};



// WEBPACK FOOTER //
// ./src/services/site-service.js